(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  !(function(d){
    var cartData = d.getElementById('cart-data-element');
    var membershipIds = [cartData.dataset.monthlyid, cartData.dataset.annualid, cartData.dataset.twoyearid];

    var removeButtons = d.getElementsByClassName('cart-product-remove');
    for(var i=0; i<removeButtons.length; i++) {
      var button = removeButtons[i];
      if(membershipIds.includes(button.dataset.varientid)) {
        button.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          var removeUrl = e.target.href;
          var modalButton = d.getElementById('remove-membership-continue');
          modalButton.setAttribute('href', removeUrl);
          var modal = d.getElementById('cart-remove-membership-modal');
          modal.style.display = 'block';
        });
      }
    }

    // Prevent the page from reloading when clicking on the minus button 
    // when there is only one of the product left
    $('.product-minus').each((index, element) => {
      var input = $(element).siblings('input');
      var quantity = input.val();
      if(quantity == 1) {
        $(element).addClass('disabled');
        $(element).click((e) => {
          e.preventDefault();
          e.stopPropagation(); 
        });
      }
    });

  }(document)); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credera-fitpass-cta"]) return;
  try {
    

jQuery('.fitpass-cta .primary-button').on('click', function(e) {

  	e.preventDefault();

	console.log('submit');

  	$.post("/cart/add.js", {
        items: [{id: 14542361755761,quantity: 1}]
    }, function(i) {
        window.location.href = "/cart";
    });

});
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credera-full-width-video-section"]) return;
  try {
    
!(function(d){
  var video = d.getElementById('video-banner');
  video.volume = 0.0;

  setTimeout(function(){  
    video.play().then(function() {
      $('#play-controller').removeClass('off');
      $('#play-controller').addClass('on');
    });
  }, 100);

  $('#volume-controller').click(function() {
    if(video.volume > 0.0) {
      video.volume = 0.0;
      $('#volume-controller').removeClass('on');
      $('#volume-controller').addClass('off');
      console.log('VOLUME OFF');
    } else {
      video.volume = 1.0;
      $('#volume-controller').removeClass('off');
      $('#volume-controller').addClass('on');
      console.log('VOLUME ON');
    }
  }); 

  $('#play-controller').click(function() {
    if(video.paused) {
      video.play().then().catch(function(err) {
        alert(err);
      });
      $('#play-controller').removeClass('off');
      $('#play-controller').addClass('on');
      console.log('PLAYING');
    } else {
      video.pause();
      $('#play-controller').removeClass('on');
      $('#play-controller').addClass('off');
      console.log('PAUSING');
    }
  });
}(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credera-homepage-endorsements"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.endorsement-list').slick({
      dots: true,
      arrows: true,
      prevArrow: '<button class="previous carousel-control" type="button" aria-label="Previous"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Left Arrow</title><path d="m22.5 4.563h-17.385l1.941-1.9215c0.13933-0.13708 0.24999-0.30047 0.32552-0.48074s0.11442-0.37373 0.11442-0.56919c0-0.19545-0.03889-0.389-0.11442-0.56927s-0.18619-0.34367-0.32551-0.48074c-0.2827-0.27912-0.66397-0.43561-1.0612-0.43561-0.39727-1e-6 -0.77856 0.15649-1.0612 0.43561l-4.5 4.4565c-0.12624 0.12732-0.22793 0.27674-0.3 0.44091-0.020738 0.04881-0.038281 0.09897-0.052505 0.15006-0.04049 0.11817-0.064718 0.24133-0.072006 0.36603-0.003628 0.04993-0.003628 0.10003-2e-8 0.14996 0.0045823 0.15948 0.035506 0.31707 0.091506 0.46646 0.002795 0.01368 0.006305 0.02725 0.010506 0.04056 0.073035 0.1623 0.17465 0.31018 0.3 0.43652 0.012 0.0135 0.016507 0.03146 0.030007 0.04496l4.5 4.4565c0.28289 0.2788 0.66408 0.435 1.0612 0.435 0.39716 0 0.77837-0.1562 1.0613-0.435 0.13932-0.1371 0.24999-0.3005 0.32552-0.4808s0.11441-0.3737 0.11441-0.5692-0.03888-0.3889-0.11441-0.56918c-0.07553-0.18027-0.1862-0.34376-0.32552-0.48084l-1.941-1.9215 17.378 1e-5c0.2016 0.01111 0.4033-0.01895 0.5928-0.08844 0.1896-0.0695 0.363-0.1769 0.5096-0.31568 0.1467-0.13877 0.2635-0.30601 0.3433-0.49145 0.0798-0.18545 0.121-0.38524 0.121-0.58713s-0.0412-0.40168-0.121-0.58713c-0.0798-0.18544-0.1966-0.35267-0.3433-0.49145-0.1466-0.13878-0.32-0.24618-0.5096-0.31568-0.1895-0.06949-0.3912-0.09964-0.5928-0.08853z" clip-rule="evenodd" class="fill" fill="#fff" fill-rule="evenodd"/></svg></button>',
      nextArrow: '<button class="next carousel-control" type="button" aria-label="Next"><svg fill="none" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg"><title>Right Arrow</title><path d="m1.4999 4.563h17.385l-1.941-1.9215c-0.1393-0.13708-0.25-0.30047-0.3255-0.48074s-0.1144-0.37373-0.1144-0.56919c0-0.19545 0.0389-0.389 0.1144-0.56927s0.1862-0.34367 0.3255-0.48074c0.2827-0.27912 0.664-0.43561 1.0613-0.43561 0.3972-1e-6 0.7785 0.15649 1.0612 0.43561l4.5 4.4565c0.1263 0.12732 0.228 0.27674 0.3 0.44091 0.0208 0.04881 0.0383 0.09897 0.0525 0.15006 0.0405 0.11817 0.0647 0.24133 0.072 0.36603 0.0037 0.04993 0.0037 0.10003 0 0.14996-0.0045 0.15948-0.0355 0.31707-0.0915 0.46646-0.0028 0.01368-0.0063 0.02725-0.0105 0.04056-0.073 0.1623-0.1746 0.31018-0.3 0.43652-0.012 0.0135-0.0165 0.03146-0.03 0.04496l-4.5 4.4565c-0.2829 0.2788-0.6641 0.435-1.0612 0.435-0.3972 0-0.7784-0.1562-1.0613-0.435-0.1393-0.1371-0.25-0.3005-0.3255-0.4808s-0.1144-0.3737-0.1144-0.5692 0.0389-0.3889 0.1144-0.56918c0.0755-0.18027 0.1862-0.34376 0.3255-0.48084l1.941-1.9215-17.377 1e-5c-0.20159 0.01111-0.40332-0.01895-0.59287-0.08844-0.18956-0.0695-0.36297-0.1769-0.5096-0.31568-0.14664-0.13877-0.26343-0.30601-0.34325-0.49145-0.079821-0.18545-0.12099-0.38524-0.12099-0.58713s0.041164-0.40168 0.12098-0.58713c0.079823-0.18544 0.19662-0.35267 0.34325-0.49145 0.14664-0.13878 0.32005-0.24618 0.50961-0.31568 0.18955-0.06949 0.39128-0.09964 0.59287-0.08853z" clip-rule="evenodd" fill="#fff" class="fill" fill-rule="evenodd"/></svg></button>',
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credera-homepage-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $("#homepageScrollDown").click(function(e) {
      e.preventDefault();
      var divId = $(this).attr("href");

      let el = document.querySelector(divId);

      if (el) {
        el.scrollIntoView({ behavior: 'smooth', alignment: 'top'});
      }
    });  
  })(); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-video-commercial"]) return;
  try {
    
!(function(d){
  var video = d.getElementById('video-banner');
  video.volume = 0.0;

  setTimeout(function(){  
    video.play().then(function() {
      $('#play-controller').removeClass('off');
      $('#play-controller').addClass('on');
    });
  }, 100);

  $('#volume-controller').click(function() {
    if(video.volume > 0.0) {
      video.volume = 0.0;
      $('#volume-controller').removeClass('on');
      $('#volume-controller').addClass('off');
      console.log('VOLUME OFF');
    } else {
      video.volume = 1.0;
      $('#volume-controller').removeClass('off');
      $('#volume-controller').addClass('on');
      console.log('VOLUME ON');
    }
  }); 

  $('#play-controller').click(function() {
    if(video.paused) {
      video.play().then().catch(function(err) {
        alert(err);
      });
      $('#play-controller').removeClass('off');
      $('#play-controller').addClass('on');
      console.log('PLAYING');
    } else {
      video.pause();
      $('#play-controller').removeClass('on');
      $('#play-controller').addClass('off');
      console.log('PAUSING');
    }
  });
}(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
     
!(function(d){
  var announcementBannerDesktop = d.getElementById('announcement-content-desktop');
  var announcementBannerMobile = d.getElementById('announcement-content-mobile');
  var announcementData = d.getElementById('announcement-data');
  var sideBarBtn = d.getElementById('side-menu-button-desktop');
  var sideBarBtnMobile = d.getElementById('side-menu-button-mobile');
  var sideBar = d.getElementById('nav-side-bar-desktop');
  var sideBarMobile = d.getElementById('nav-side-bar-mobile');
  var background = d.getElementById('nav-background-screen');
  var closeBtn = d.getElementById('close-btn-desktop');
  var closeBtnMobile = d.getElementById('close-btn-mobile');
  var pageContent = d.getElementById('page-content');
  var footer = d.getElementById('shopify-section-footer');

  function blockBackground() {
    pageContent.classList.add('frozen');
    background.classList.add('active'); 
    footer.style.display = 'none';
  } 
 
  function unblockBackground() {
    pageContent.classList.remove('frozen');
    background.classList.remove('active');
    footer.style.display = 'block'; 
  }

  // Mobile - Close the side bar
  function closeMobileSideBar() {
    sideBarMobile.classList.remove('active');
    sideBarBtnMobile.style.display = 'block';
    closeBtnMobile.style.display = 'none';
  }

  // Desktop - Close the side bar
  function closeSideBar() {
    sideBar.classList.remove('active');
    closeMobileSideBar();
    unblockBackground();
  }

  // Desktop - Open the side bar on button click
  sideBarBtn.addEventListener('click', function() {
    sideBar.classList.add('active');
    blockBackground();
  });
  // Desktop and Mobile - Close the side bar 
  background.addEventListener('click', closeSideBar);
  closeBtn.addEventListener('click', closeSideBar);

  // Mobile - Open the side bar on button click
  sideBarBtnMobile.addEventListener('click', function() {
    sideBarMobile.classList.add('active');
    sideBarBtnMobile.style.display = 'none';
    closeBtnMobile.style.display = 'block';
    blockBackground();
  });

  // Mobile - Close the side bar
  closeBtnMobile.addEventListener('click', function () {
    closeMobileSideBar();
    unblockBackground();
  });

  // Announcement bar
  function populateAnnouncementBanner() {
    var data = [];
    if(announcementData.dataset.text_1 != "") {
      data.push({
        text: announcementData.dataset.text_1,
        url: announcementData.dataset.url_1
      });
    }
    if(announcementData.dataset.text_2 != "") {
      data.push({
        text: announcementData.dataset.text_2,
        url: announcementData.dataset.url_2
      });
    }
    if(announcementData.dataset.text_3 != "") {
      data.push({
        text: announcementData.dataset.text_3,
        url: announcementData.dataset.url_3
      });
    }

	jQuery('.prev').on("click", function (e) {
        if(data.length > 1) {
            announcementBannerDesktop.childNodes[activeIndex].classList.remove('visible');
            announcementBannerMobile.childNodes[activeIndex].classList.remove('visible');
            if(activeIndex == 0) {
              activeIndex = data.length - 1;
            } else {
              activeIndex--;
            }
            announcementBannerDesktop.childNodes[activeIndex].classList.add('visible');
            announcementBannerMobile.childNodes[activeIndex].classList.add('visible');
        }
        clearInterval(d.interval);
    });
    jQuery('.next').on("click", function (e) {
        if(data.length > 1) {
            announcementBannerDesktop.childNodes[activeIndex].classList.remove('visible');
            announcementBannerMobile.childNodes[activeIndex].classList.remove('visible');
            if(activeIndex == data.length - 1) {
              activeIndex = 0;
            } else {
              activeIndex++;
            }
            announcementBannerDesktop.childNodes[activeIndex].classList.add('visible');
            announcementBannerMobile.childNodes[activeIndex].classList.add('visible');
        }
        clearInterval(d.interval);
    });

    for(var i=0; i<data.length; i++) {
      var textElement = null;
      if(data[i].url != "") {
        textElement = `<a href="${data[i].url}" class="announcement-text ${i == 0 ? 'visible' : ''}">${data[i].text}</a>`;
      } else {
        textElement = `<p class="announcement-text ${i == 0 ? 'visible' : ''}">${data[i].text}</p>`;
      }
      var desktopTemplate = d.createElement('template');
      var mobileTemplate = d.createElement('template');
      desktopTemplate.innerHTML = textElement;
      mobileTemplate.innerHTML = textElement;
      announcementBannerMobile.append(desktopTemplate.content.firstChild);
      announcementBannerDesktop.append(mobileTemplate.content.firstChild); 
      
    }

    // Shuffle through the announcements
    var activeIndex = 0;
    if(data.length > 1) {
      setInterval(function() {
        announcementBannerDesktop.childNodes[activeIndex].classList.remove('visible');
        announcementBannerMobile.childNodes[activeIndex].classList.remove('visible');
        if(activeIndex == data.length - 1) {
          activeIndex = 0;
        } else {
          activeIndex++;
        }
        announcementBannerDesktop.childNodes[activeIndex].classList.add('visible');
        announcementBannerMobile.childNodes[activeIndex].classList.add('visible');
      }, 6000);
    }else{
			jQuery('.next').remove();
			jQuery('.prev').remove();
jQuery('.desktop-banner-toppadding').removeClass('desktop-banner-toppadding');
		}
	jQuery('.next').css('display','block');
	jQuery('.prev').css('display','block');
  }
  populateAnnouncementBanner();

}(document));
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-redirect"] && !Shopify.designMode) return;
  try {
    
// Get variant id from localstorage
const variantId = JSON.stringify(localStorage.getItem('variant'));

// Check if not empty string
if (variantId != '') {
	// add variant to cart
	console.log('Add variant to cart, remove from localstorage and redirect customer to checkout.', variantTd);
	return;
	// redirect user to cart
}
// redirect user to homepage
console.log('Remove variantId from localstorage and redirect customer to homepage.');

  } catch(e) { console.error(e); }
})();
})();
